import type { ReactNode } from 'react';
import { Paper, Stack, Text, Title } from '@mantine/core';

interface AuthCardProps {
  readonly title: string;
  readonly description?: ReactNode;
  readonly children: ReactNode;
  /** Нижний блок ссылок (вход/регистрация/отмена). */
  readonly footer?: ReactNode;
}

// Единая карточка auth-экранов: заголовок + описание + содержимое + футер ссылок.
// Без рамки и тени (по дизайн-решению — формы borderless).
export default function AuthCard({ title, description, children, footer }: AuthCardProps) {
  return (
    <Paper p={{ base: 0, sm: 'md' }}>
      <Stack gap="lg">
        <Stack gap={4}>
          <Title order={1} fz={{ base: 'xl', sm: 28 }}>
            {title}
          </Title>
          {description ? (
            <Text c="gray.7" size="sm">
              {description}
            </Text>
          ) : null}
        </Stack>

        {children}

        {footer ? <Stack gap="xs">{footer}</Stack> : null}
      </Stack>
    </Paper>
  );
}
